import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { linkProcedures } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function linkAccountProcedures({
  accountId,
  payload,
}: TVariables): Promise<TResult> {
  const response = await fetch(linkProcedures(accountId), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  payload: any;
};
type TSnapshot = unknown;

function useLinkProcedures(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const formData = await linkAccountProcedures(params);
    if (formData.Data) {
      queryClient.invalidateQueries(['get_procedure_builder_procedures'], {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(['get_procedure'], {
        refetchInactive: true,
      });
    } else if (formData.Errors) throw formData;
    return formData;
  });
}

export { useLinkProcedures };
